import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './common/lang/i18n'
import { ScreeningPopup } from './common/popup'
import {
  getCompanyStatus,
  getCompanyType,
  getICB,
  getLegalForm,
  getListingStatus,
  getLocation,
  getScreeningIndicators,
  getVSIC,
  getYearReports,
} from './common/store/thunk'
import { ExportFileSetting } from './exportFileSetting'
import { SavedCriteria } from './savedCriteria'
import { resetStore as resetStoreSaved } from './savedCriteria/store/slice'
import { SelectCriteria } from './selectCriteria'

const Screening = ({ isSavedCriteriaScreen }) => {
  const [isInExportScreen, setIsInExportScreen] = useState(false)

  const navigateToExportScreen = () => setIsInExportScreen(true)
  const navigateToSelectScreen = () => setIsInExportScreen(false)

  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getScreeningIndicators())
    dispatch(getVSIC())
    dispatch(getICB())
    dispatch(getLocation())
    dispatch(getCompanyStatus())
    dispatch(getLegalForm())
    dispatch(getCompanyType())
    dispatch(getListingStatus())
  }, [locale])

  useEffect(() => {
    dispatch(getYearReports())
  }, [])

  useEffect(() => {
    return () => {
      dispatch(resetStoreSaved())
    }
  }, [])

  return (
    <div className="positionRelative wh100" style={{ zIndex: 9 }}>
      {isSavedCriteriaScreen ? (
        <SavedCriteria />
      ) : isInExportScreen ? (
        <ExportFileSetting navigateToSelectScreen={navigateToSelectScreen} />
      ) : (
        <SelectCriteria navigateToExportScreen={navigateToExportScreen} />
      )}

      <ScreeningPopup />
    </div>
  )
}

export default Screening
